<template>
  <div :class="[prefix,`${prefix}-wrap`]">
    <div class="side-bar">
      <Poptip
        trigger="hover"
        placement="left"
        class="qq-pop"
      >
        <div class="item kefu">
          <a :href="'tencent://message/?uin=' + qq + '&Site=Sambow&Menu=yes'">
            <span class="icon iconfont iconkefu "></span>
            <div class="word">在线咨询</div>
          </a>
        </div>
        <div
          class="mobile-qq"
          slot="content"
        >
          <div
            v-for="(item,index) in qq"
            :key="item+index"
          >
            <a :href="'tencent://message/?uin=' + item + '&Site=Sambow&Menu=yes'">
              <img
                src="../../../static/img/qq.png"
                alt=""
              >
              在线客服{{index + 1}}
            </a>
          </div>
        </div>
      </Poptip>
      <!-- <div class="item kefu">
        <a :href="'tencent://message/?uin=' + qq + '&Site=Sambow&Menu=yes'">
          <span class="icon iconfont iconkefu "></span>
          <div class="word">在线咨询</div>
        </a>
      </div> -->
      <div
        class="item"
        @click="toShoppingCart"
        @mouseenter="showtip1"
        @mouseleave="hideTip1"
      >
        <div
          class="cartNum"
          v-if="shoppingCartTotal>0"
        ><span>{{shoppingCartTotal == 0 ? '' : shoppingCartTotal > 99 ? '99+' : shoppingCartTotal}}</span></div>
        <span class="icon iconfont iconcart_plus"></span>
        <div
          class="tab-text"
          :style="{left:left1}"
        >
          我的购物车
        </div>
      </div>
      <div
        class="item"
        @click="toQuickOrder"
        @mouseenter="showtip2"
        @mouseleave="hideTip2"
      >
        <span class="icon iconfont iconorder-unpay"></span>
        <div
          class="tab-text"
          :style="{left:left2}"
        >
          批量询价
        </div>
      </div>
      <Poptip
        trigger="hover"
        content="回到顶部"
        placement="left"
      >
        <div class="item">
          <span class="icon iconfont iconmobile"></span>
        </div>
        <div
          class="mobile-app"
          slot="content"
        >
          <div class="qrcode"><img :src="wechatImg"></div>
          <div class="text">
            <div>扫一扫,关注鼎阳小程序</div>
            <div style='color:green'>手机采购,移动办公</div>
          </div>
        </div>
      </Poptip>
      <BackTop class="return-top">
        <Poptip
          trigger="hover"
          content="回到顶部"
          placement="left"
        >
          <img
            src="/static/img/header/return-top.png"
            alt=""
          >
        </Poptip>
      </BackTop>
    </div>
  </div>
</template>

<script>
import '@/styles/components/header/sideBar.scss';
import { mapGetters, mapActions } from 'vuex';
const prefix = 'cpt-sidebar';
export default {
  data () {
    return {
      prefix,
      qq: [],
      left1: '48px',
      left2: '48px',
      wechatImg: ''
    };
  },
  computed: {
    ...mapGetters({
      shoppingCartTotal: 'getShoppingCartTotal'
    })
  },
  methods: {
    ...mapActions({
      getOnlineQQ: 'getOnlineQQ',
      getWxCodeUnlimit: 'getWxCodeUnlimit'
    }),
    toShoppingCart () {
      this.$router.push('/shoppingCart');
    },
    toQuickOrder () {
      this.$router.push('/findProduct');
    },
    showtip1 () {
      this.left1 = '-120px';
    },
    hideTip1 () {
      this.left1 = '48px';
    },
    showtip2 () {
      this.left2 = '-120px';
    },
    hideTip2 () {
      this.left2 = '48px';
    }
  },
  created () {
    this.getOnlineQQ().then(res => {
      if (res.Success) {
        let arr = [];
        let index1 = res.Data.indexOf(',');
        let index2 = res.Data.indexOf('，');
        if (index1 === -1 && index2 === -1) {
          arr = res.Data.split(',');
        } else if (index1 === -1) {
          arr = res.Data.split('，');
        } else if (index2 === -1) {
          arr = res.Data.split(',');
        }
        this.qq = arr;
      }
    });
    this.getWxCodeUnlimit().then(res => {
      if (res.Success) {
        this.wechatImg = res.Data.ImageUrl;
      }
    });
  }

};
</script>

<style lang='scss' scoped>
</style>



// WEBPACK FOOTER //
// src/components/header/SideBar.vue